import type { ReactNode } from 'react';

/**
 * @public
 */
export type TooltipProps = {
  hidden?: boolean;
  children?: (payload: Record<string, unknown>) => ReactNode;
};

export const Tooltip = <T extends TooltipProps>(prefix: string) => {
  const component = (props: T) => null;
  component['displayName'] = `${prefix}.Tooltip`;

  return component;
};
